import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { getComponentForStage } from '../../../config/stageConfig';
import Header from './Header';
import TitleCard from './kyc/TitleCard';
// import { tracer } from '../../../otel';

function ConsumerData() {
  const { stage, subStage } = useSelector(state => state.eligibility);
  const { referenceId } = useSelector(state => state.dashboard);

  // const span = tracer.startSpan("consumer", {
  //   attributes: {
  //     "custom.reference_id": referenceId, // <- add your custom reference_id here
  //   },
  // });
  

  // useMemo to recalculate component only when stage/subStage changes
  const Component = useMemo(() => {

    const NewComponent = getComponentForStage(stage, subStage);

    return NewComponent;
  }, [stage, subStage]); // Dependencies: recalculate when these change

  // span.end()

  // Memoize the error/fallback JSX to prevent re-creation
  const fallbackContent = useMemo(() => (
    <div className="col-12 d-flex justify-content-center align-items-center d-none" style={{ minHeight: '300px' }}>
      <div className="text-center">
        <div className="alert alert-warning">
          <h5><i className="icon-warning me-2"></i>Stage Not Available</h5>
          <p>The requested application stage is not available.</p>
          <div className="mt-2 p-3 rounded">
            <strong>Debug Information:</strong><br />
            <strong>Current Stage:</strong> <code>{stage || 'undefined'}</code><br />
            <strong>Sub-Stage:</strong> <code>{subStage || 'undefined'}</code><br />
            <strong>Reference ID:</strong> <code>{referenceId || 'undefined'}</code>
          </div>
          <div className="mt-3">
            <button
              className="btn btn-primary me-2"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => window.location.href = '/dashboard'}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  ), [stage, referenceId]); // Dependencies for fallback content


  return (
    <div className="position-relative">
      <Header />
      <div className="container-fluid kyc-tab">
        <div className={`row bg-white`}>
          {subStage !== 'fos_selfie' && <TitleCard />}
          {Component ? <Component /> : fallbackContent}
        </div>
      </div>
    </div>
  )
}

// Memoize the entire component to prevent re-renders when props don't change
export default React.memo(ConsumerData);
